<script setup>
import { getCurrentInstance, ref, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";

const { proxy } = getCurrentInstance();
const { t } = useI18n();

const username_lg = ref("");
const password_lg = ref("");
const captchaSvg = ref("");
const captchaAnswer = ref("");
const loginPopupRef = ref(null);

const refreshCaptcha = async (e) => {
  e?.stopPropagation();
  try {
    const res = await proxy.axios.get(proxy.api_captcha);
    captchaSvg.value = res.data.svg;
  } catch (error) {
    console.error("CAPTCHA load error:", error);
  }
};

// MutationObserver를 사용하여 팝업 요소의 클래스 변화 감지
let observer;
onMounted(() => {
  const target = loginPopupRef.value;
  if (target) {
    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (target.classList.contains('active')) {
            refreshCaptcha();
          }
        }
      });
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

const login = (e) => {
  e.preventDefault();
  proxy.axios
    .post(proxy.api_login, {
      username: username_lg.value,
      password: password_lg.value,
      captchaAnswer: captchaAnswer.value,
    })
    .then((res) => {
      if (!res.data.error) {
        proxy.$store.commit("setUser", res.data);
        proxy.$swal.success({
          title: t(res.data.message),
        });
      } else {
        // CAPTCHA 갱신
        refreshCaptcha();
        proxy.$swal.error({
          title: t(res.data.error),
        });
      }
    })
    .catch((e) => {
      refreshCaptcha();
      let title = t(e.response?.data?.error || "auth.loginFailed");
      let message = e.response?.data?.message || "";
      try {
        message = JSON.parse(message);
      } catch {
        // JSON 파싱 실패
      }
      if (typeof message === "string") {
        message = t(message);
      } else {
        message = t(message[0]?.message || "");
      }
      proxy.$swal.error({
        title,
        text: message,
      });
    });
};
</script>

<template>
  <div class="wptb-header--cart mr-3" style="z-index: 100" v-if="!$store.state.loggedIn" @click.stop>
    <div class="wptb-cart-box shogun-login" ref="loginPopupRef">
      <div class="wptb-grand-total">
        <ul>
          <li>
            {{ t('auth.login') }}
          </li>
          <li>
            <form method="post" name="LoginFrm" @submit="(e) => login(e)">
              <div class="wptb-form--inner">
                <div class="row">
                  <div class="col-lg-12 col-md-12">
                    <div class="form-group">
                      <input
                        class="form-control"
                        type="text"
                        name="username_lg"
                        v-model="username_lg"
                        :placeholder="t('auth.username')"
                        style="border-color: #3d3d3d"
                        @click="(evt) => evt.stopPropagation()"
                      />
                    </div>
                  </div>

                  <div class="col-lg-12 col-md-12">
                    <div class="form-group">
                      <input
                        class="form-control"
                        type="password"
                        name="password_lg"
                        v-model="password_lg"
                        :placeholder="t('auth.password')"
                        style="border-color: #3d3d3d"
                        @click="(evt) => evt.stopPropagation()"
                      />
                    </div>
                  </div>

                  <div class="col-lg-12 col-md-12">
                    <div class="form-group">
                      <div v-if="captchaSvg" class="captcha-container mb-2" v-html="captchaSvg"></div>
                      <div class="d-flex align-items-center">
                        <input
                          class="form-control"
                          type="text"
                          v-model="captchaAnswer"
                          :placeholder="t('auth.captcha')"
                          style="border-color: #3d3d3d"
                          @click="(evt) => evt.stopPropagation()"
                        />
                        <button 
                          type="button" 
                          class="btn btn-sm ml-2" 
                          @click="refreshCaptcha"
                          style="background: none; border: none;"
                        >
                          <i class="bi bi-arrow-clockwise"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12">
                    <div class="form-group" v-if="false">
                      <input type="checkbox" name="remmeber" />
                      <label for="remmeber" class="text-capitalize">
                        {{ t('auth.rememberPassword') }}
                      </label>
                    </div>

                    <div class="wptb-item--button">
                      <button class="btn-two white" type="submit">
                        <span class="btn-wrap">
                          <span class="text-first">
                            {{ t('auth.login') }}
                          </span>
                          <span class="text-second">
                            <i class="bi bi-plus"></i>
                          </span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </li>
        </ul>
        <div class="wptb-item--button" v-if="false">
          <a
            href="javascript:void(0)"
            class="btn-three"
            style="height: 60px; font-size: var(--fs-16)"
          >
            <div class="btn-wrap">
              <span class="text-first">{{ t('auth.register') }}</span>
              <span class="text-second">{{ t('auth.register') }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.captcha-container {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 4px;
  background-color: #f9f9f9;
  display: flex;
  justify-content: center;
}
.ml-2 {
  margin-left: 0.5rem;
}
</style>
